import React from 'react';
import PropTypes from 'prop-types';

// ** Extend Core's Collapse molecule **
export const Collapse = ({
  buttonContent,
  children,
  isActive,
  onClick,
  ...otherProps
}) => {
  return (
    <div className="mz-collapse">
      <button
        onClick={onClick}
        className="mz-collapse__button"
        className={`mz-collapse__button ${isActive ? 'active' : ''}`}
        {...otherProps}
      >
        {buttonContent}
        <i className={`mz-svg mz-svg-chevron mz-svg--grey${isActive ? 'visible' : ''}`}></i>
      </button>
      <div className={isActive ? "mz-collapse__box visible" : "mz-collapse__box"}>
        {children}
      </div>
    </div>
  )
}

Collapse.propTypes = {
  buttonContent: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
}

Collapse.defaultProps = {
  isActive: false
}

export default Collapse;